import React from 'react';
import * as icons from 'react-icons/fa';
import { FaSackDollar } from 'react-icons/fa6';

// Persisted glyph names predate the icon package's exported names.
const GLYPH_ALIASES = {
  FaController: 'FaGamepad',
  FaVr: 'FaVrCardboard',
  FaPizza: 'FaPizzaSlice',
  FaCake: 'FaBirthdayCake',
  FaCandy: 'FaCandyCane',
  FaHeadset: 'FaHeadphones',
  FaBaseball: 'FaBaseballBall',
  FaGolf: 'FaGolfBall',
  FaVolleyball: 'FaVolleyballBall',
  FaFishing: 'FaFish',
  FaPhoto: 'FaCamera',
  FaHandHoldingBox: 'FaHandHolding',
  FaCoin: 'FaCoins',
  FaIdea: 'FaLightbulb',
  FaSpray: 'FaSprayCan',
  FaWeather: 'FaUmbrella',
  FaFlower: 'FaSeedling',
  FaAccommodation: 'FaBed',
  FaLandmarkFlag: 'FaFlag',
  FaTorii: 'FaToriiGate',
  FaTourism: 'FaCamera',
  FaTicket: 'FaTicketAlt',
  FaTrendingUp: 'FaArrowUp',
  FaTrendingDown: 'FaArrowDown',
  FaCalc: 'FaCalculator',
  FaBuildingUser: 'FaBuilding',
  FaFactory: 'FaWarehouse',
  FaStorage: 'FaWarehouse',
  FaDeal: 'FaHandshake',
  FaOrg: 'FaProjectDiagram',
  FaTeam: 'FaUsers',
  FaManager: 'FaUserTie',
  FaTasks: 'FaClipboardList',
  FaHeating: 'FaFire',
  FaTelephone: 'FaPhone',
  FaInternet: 'FaWifi',
  FaCable: 'FaTv',
  FaNews: 'FaNewspaper',
  FaMail: 'FaEnvelope',
  FaDelivery: 'FaShippingFast',
};

/** Displays a user-selected, persisted glyph. Product icon-name mapping stays in the feature. */
export default function StoredIcon({ name, ...props }) {
  const glyphName = GLYPH_ALIASES[name] || name;
  const Icon = glyphName === 'FaSackDollar' ? FaSackDollar
    : /^Fa[A-Z]/.test(glyphName || '') && Object.prototype.hasOwnProperty.call(icons, glyphName)
      ? icons[glyphName] : icons.FaQuestionCircle;
  return <Icon {...props} />;
}
